import { useEffect, useRef, useState } from 'react';
import Switch from "react-switch";

import { VJFPUserService } from 'app/services/VJFPUserService';
import { useAuth } from 'app/context/auth-context';
import { useAppContext } from 'app/context/app-context';
import { JobFairStatus, Roles } from 'app/types';
import { RxSubscription } from 'app/RxSubscriptions';

function AvailabilitySelector() {
  const vjfpService = new VJFPUserService();
  const { user } = useAuth();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  const [isEnabled, setIsEnabled] = useState<boolean>(false)
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string>('');
  const { jobFair } = useAppContext();
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const updateVjfpUserStatus = async (value: boolean) => {
    if (isUpdating || !user?.id || !jobFair?.id) return;
    const previous = isAvailable;
    setIsAvailable(value);
    setIsUpdating(true);
    setUpdateError('');
    try {
      await vjfpService.updateAvailability(jobFair.id, user.organizationId, user.id, value);
    } catch (err) {
      if (isMountedRef.current) {
        setIsAvailable(previous);
        setUpdateError('Failed to update availability. Please try again.');
      }
    } finally {
      if (isMountedRef.current) {
        setIsUpdating(false);
      }
    }
  };

  useEffect(() => {
    const getVjfpIsAvailable = async () => {
      if (jobFair?.id && user?.id) {
        const vjfpuser = await vjfpService.getById(user!.organizationId, user.id);
        if(vjfpuser?.isAvailableForChat){
          await vjfpService.updateAvailability(jobFair.id, user.organizationId, user.id, false).catch(err => console.log(err));
        }
      }
    };
    getVjfpIsAvailable();
   }, [jobFair?.id,user?.id]);

   useEffect(() => {
    if(!user?.id) 
      return;
     const sub = RxSubscription.onUpdateVJFPUserByIdObservable().subscribe((value)=> {
      if(value && value.id === user?.id){
        setIsAvailable(value.isAvailableForChat === true);
      }
     });
     return () => {
       sub.unsubscribe();
     }
   }, [user?.id]);

  useEffect(() => {
    let _isEnabled: boolean = false;
    if(jobFair != null && user?.roles?.includes(Roles.Recruiter) && (jobFair.status === JobFairStatus.Started || jobFair.status === JobFairStatus.ClosingSession))
      _isEnabled = true;
    setIsEnabled(_isEnabled)
  }, [jobFair, user]);

  return (
    <label>
      <span className='form-label fs-5 fw-bolder text-dark align-middle'>{isAvailable? "": "Turn on to start next interview :"} </span>
      <Switch onChange={(value) => updateVjfpUserStatus(value)} checked={isAvailable} disabled={isUpdating} offColor={'#CD001A'}/>
      {updateError && <span className='text-danger fs-7 ms-2'>{updateError}</span>}
    </label>
  );
}
export { AvailabilitySelector };
